import { TextPassage } from '@petsmart-ui/sparky';

import { ResponsivePicture } from '@libs/shared-ui';

import { type ImageType, useProduct } from '@/entities/product';

export const ProductSummary = () => {
    const { product } = useProduct();

    if (!product) return null;

    const firstImage = product.media.find(item => item.type === 'image') as ImageType | undefined;

    return (
        <div className="frequency-calculator-drawer__product">
            <div className="frequency-calculator-drawer__product-image">
                <ResponsivePicture src={firstImage?.url ?? ''} alt={product.name} size={{ width: 64, height: 64 }} />
            </div>
            <TextPassage className="frequency-calculator-drawer__product-name">{product.name}</TextPassage>
        </div>
    );
};
